// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"e5c55e8f","346":"3eeafd44","507":"d051d513","691":"1c272c04"}[chunkId] + ".chunk.css";
};